/**
 * Core Engine - Fase 1 AgTracker
 * Visitor → Session → PageView
 */

export {
  getOrCreateVisitor,
  getOrCreateVisitorSync,
  type GetOrCreateVisitorOptions,
} from './visitor';

export {
  getOrCreateSession,
  touchSession,
  setSessionEngagementScore,
  getStoredSession,
  type GetOrCreateSessionOptions,
} from './session';

export {
  setPageViewCallback,
  clearPageViewCallback,
  trackPageView as trackPageViewCore,
  getCurrentPageViewState,
  type PageViewCallback,
} from './pageview';

export {
  initCoreTracker,
  destroyCoreTracker,
  trackPageView,
  getVisitor,
  getSession,
  getCoreSessionId,
  getCoreVisitorId,
  getPageViewState,
  type CoreTrackerConfig,
} from './tracker';

export {
  enqueueEvent,
  flushQueue,
  flushQueueWithBeacon,
  sendPageViewImmediately,
  sendEventImmediately,
  setUnloadingFlag,
  startPeriodicFlush,
  stopPeriodicFlush,
  setupUnloadFlush,
  getQueueLength,
  getQueueStats,
} from './queue';

export type {
  QueueItem,
  QueuePriority,
  QueueItemType,
  QueueStatus,
  QueueStats,
} from './queue';

export { setupUnifiedUnloadFlush, registerUnloadHook, runUnloadDelivery } from './unload';
export {
  getQueueTelemetry,
  getStructuredTelemetry,
  getEventTimeline,
  getRetryByType,
} from './telemetry';

export { setUseQueueIndex, isQueueIndexEnabled } from './queue/queueIndex';

/** Ativa índices Map+Set na fila (rollout gradual). */
export { setUseQueueIndex as configureQueueIndex } from './queue/queueIndex';
export { getRuntimeDebugSnapshot } from './runtime/debugSnapshot';
export { getDeadLetterCount, getDeadLetterEntries, exportDeadLetterData } from './deadLetter';
export { setConsent, getConsent, shouldTrack, type ConsentState } from './consent';
export { runEventPipeline } from './pipeline';
export { sanitizeMetadata } from './sanitizeMetadata';

export type { Visitor, CoreSession, UtmData, PageViewRecord } from '../types';
